/**
 *
 * CardOverlay
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { getFinalPrice } from 'utils/stringUtils';
import Highlights from 'components/Highlights';
import { Typography } from '@material-ui/core';
import ButtonBase from '@material-ui/core/ButtonBase';
import Title from './Title';
import ArrowRight from './images/arrow-right.svg';

const styles = theme => ({
  detailsBtnWrapper: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 42,
    borderTop: '1px solid #E9ECED',
    color: theme.palette.primary.main,
    ...theme.typography.overline,
  },
  root: {
    padding: 15,
    [theme.breakpoints.down('480')]: {
      padding: '15px 30px',
    },
  },
  arrowIcon: {
    position: 'absolute',
    right: 15,
    height: 14,
  },
});

function HighlightsContent(props) {
  const {
    item: {
      title = '',
      slug,
      name = '',
      highlights = [],
      costDescription = '',
      minutes = '',
      cost = 0,
    },
    route,
    classes,
  } = props;
  /* eslint-disable */

  const charLimit = 32;
  const resourceName = title || name;
  const truncatedName = resourceName.substr(0, charLimit);
  const finalResourceName =
    resourceName.length > charLimit ? `${truncatedName}...` : truncatedName;
  const finalPrice = getFinalPrice(cost);
  return (
    <>
      <Grid container alignItems="center" spacing={0} className={classes.root}>
        <Title
          route={route}
          slug={slug}
          title={finalResourceName}
          type="card"
        />
        <Grid item xs={12}>
          <Highlights data={highlights} isOverlay noBorder />
        </Grid>
        {finalPrice > 0 || costDescription && (
          <Grid item xs={12}>
            <Typography variant="body1" align="left">
            {finalPrice === 0 ? costDescription : finalPrice}
            </Typography>
          </Grid>
        )}

        {minutes && minutes !== -1 && (
          <Grid item xs={12}>
            <Typography variant="body1" align="left">
              {minutes} {minutes < 2 ? `min` : `mins`}
            </Typography>
          </Grid>
        )}
      </Grid>
      <div className={classes.detailsBtnWrapper}>
        <ButtonBase>View Full Details</ButtonBase>
        <img src={ArrowRight} className={classes.arrowIcon} alt="Arrow" />
      </div>
    </>
  );
}

HighlightsContent.propTypes = {
  classes: PropTypes.object,
  item: PropTypes.object,
  type: PropTypes.string,
  route: PropTypes.string,
  height: PropTypes.number,
  isBig: PropTypes.bool,
  show: PropTypes.bool,
  mouseLeave: PropTypes.func,
  tooltipId: PropTypes.string,
  children: PropTypes.node,
};

HighlightsContent.defaultProps = {
  height: 348,
};

export default withStyles(styles)(HighlightsContent);
